<template>
  <div ref="tags-container-outer" class="tag_container_outer">
    <el-tooltip
      effect="dark"
      content="点击查看左侧标签页"
      placement="top-start"
    >
      <span
        class="arrow-icon arrow-icon-left"
        @click="handleMove('right')"
        @mousedown="handleAutoRemove('leftOver')"
        @mouseup="handleAutoRemove('leftOut')"
      >
        <i class="el-icon-arrow-left"></i>
      </span>
    </el-tooltip>

    <div ref="tags-container-inner" class="tags_container_inner">
      <!-- :closable="!tag.active" -->
      <el-tag
        size="medium"
        v-for="tag in cacheRouteList"
        :key="tag.name"
        :closable="!tag.pinned"
        :class="{ active: tag.active, 'is-pinned': tag.pinned }"
        @close="handleClose(tag, true)"
        @contextmenu.native.prevent.stop="openContextMenu($event, tag)"
      >
        <router-link :to="getToLink(tag)" class="tags-li-title">
          <span
            :ref="`someOneTag_${tag.title}`"
            @click="handleLink($event, tag)"
          >{{ tag.title }}</span>
        </router-link>
        <span
          v-if="tag.pinned"
          class="tag-pin-btn"
          @click.prevent.stop="handleUnpinClick(tag)"
        >
          <svg-icon icon-class="pin" />
        </span>
      </el-tag>

    </div>

    <!-- 右键菜单 -->
    <div
      v-if="contextMenu.tag"
      class="tab-context-menu"
      :style="{ left: contextMenu.x + 'px', top: contextMenu.y + 'px' }"
      @click.stop
    >
      <div
        v-if="contextMenu.tag.pinned"
        class="context-menu-item"
        @click="handleUnpinClick(contextMenu.tag)"
      >
        <span class="context-menu-icon">
          <svg-icon icon-class="pin-off" />
        </span>
        <span>取消固定</span>
      </div>
      <div
        v-else
        class="context-menu-item"
        @click="handlePinClick(contextMenu.tag)"
      >
        <span class="context-menu-icon">
          <svg-icon icon-class="pin" />
        </span>
        <span>固定</span>
      </div>
    </div>

    <el-tooltip
      effect="dark"
      content="点击查看右侧标签页"
      placement="top-start"
    >
      <span class="arrow-icon arrow-icon-right" @click="handleMove('left')">
        <i class="el-icon-arrow-right"></i>
      </span>
    </el-tooltip>
  </div>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex'
import { trackClick } from '@/utils/trackReport'
import { quick } from '@/utils/ba'

export default {
  name: 'Tabsview',
  data() {
    return {
      contextMenu: {
        x: 0,
        y: 0,
        tag: null,
      },
    }
  },
  computed: {
    // eslint-disable-next-line vue/no-unused-properties
    ...mapGetters(['cacheRouteList']),
  },
  methods: {
    /** 技改需求 20231031 https://bailongma.yuque.com/hhwu0d/nvrent/ivvalkzuuhe5yged */
    ...mapMutations({
      activeRoute(commit, r) {
        // 标记活跃
        commit('ACTIVE_CACHE_ROUTE', r)
      },
      handleClose(commit, currentRoute, isActive) {
        this.closeContextMenu()
        // 通知到 appmain做缓存删除操作 删除路由缓存
        this.$EventBus.$emit('autoRemoveCache', currentRoute)
        // 点击关闭跳转
        commit('DELETE_CACHE_ROUTE', {
          currentRoute,
          callback: (p) => {
            this.$router.push({
              path: this.getToLink(p),
            })
          },
          isActive, // 是否是原生事件点击 如果是通过点击tab关闭时 不强制跳转
        })
      },
    }),
    // 获取跳转链接
    getToLink(tag) {
      return tag?.fullPath || tag?.path
    },
    handleAutoRemove(tags) {
      const outer = this.$refs['tags-container-outer']
      const inner = this.$refs['tags-container-inner']
      if (inner.scrollWidth > outer.scrollWidth) {
        // let overAll = 0
        const interval = setInterval(() => {
          // overAll += 1
          if (tags === 'leftOver') {
            // inner.scrollLeft = inner.scrollLeft + overAll 先不加长按效果
          } else if (tags === 'leftOut') {
            clearInterval(interval)
          }
        }, 20)
      }
    },
    handleLink(e, item) {
      const inner = this.$refs['tags-container-inner']
      const endMount = 10
      let overAll = 0
      const interval = setInterval(() => {
        overAll += 1
        if (e.clientX < 340) {
          inner.scrollLeft -= overAll
        } else if (e.clientX > 1356 && e.clientX < 1406) {
          inner.scrollLeft += overAll
        }
        if (overAll === endMount) {
          clearInterval(interval)
        }
      }, 16)
      /** 点击时 需要将其他的active换成false 当前这个 */
      setTimeout(() => {
        this.activeRoute(item)
      }, 10)
    },
    handleMove(tag) {
      const outer = this.$refs['tags-container-outer']
      const inner = this.$refs['tags-container-inner']
      const endMount = 20
      if (inner.scrollWidth > outer.scrollWidth) {
        let overAll = 0
        const interval = setInterval(() => {
          overAll += 1
          if (tag === 'left') {
            inner.scrollLeft += overAll
          } else if (tag === 'right') {
            inner.scrollLeft -= overAll
          }
          if (overAll === endMount) {
            clearInterval(interval)
          }
        }, 12)
      }
    },
    findCacheRouteIndex(route = this.$route) {
      const index = this.cacheRouteList.findIndex(
        (cacheRoute) =>
          cacheRoute.name === route.name && cacheRoute.path === route.path,
      )
      return [index, index !== -1 ? this.cacheRouteList[index] : null]
    },
    // 检索所有当前的缓存内容 找出需要刷新的内容
    autoRefreshCache(route = this.$route) {
      const { parent = null } = route.meta
      if (!parent) return
      const cacheRouteIndex = (value) => {
        if (!value) return
        const [index, cacheRoute] = this.findCacheRouteIndex(value)
        if (index === -1) return
        // 通知到 appmain做缓存删除操作 删除路由缓存
        this.$EventBus.$emit('autoRemoveCache', cacheRoute)
      }
      if (Array.isArray(parent)) {
        parent.forEach((element) => {
          cacheRouteIndex(element)
        })
        return
      }
      cacheRouteIndex(parent)
    },
    handleRemoveCurrent(componentInstance, dataKey, route, refreshStatus) {
      // 通过ref tags-container-inner 获取要删除的route 触发删除  :key="tag.name"
      // route === this.$route route 不传递也行
      const [index] = this.findCacheRouteIndex(route) // tab里没有就不需要刷新处理
      if (index === -1) return
      // 固定标签仅阻止关闭，不应阻止关联父路由刷新
      if (!this.cacheRouteList[index].pinned) {
        // 删除tab 通过store 变更 cacheRouteList
        this.handleClose(this.cacheRouteList[index], false)
      }
      // refreshStatus 代表关联父路由刷新状态
      if (refreshStatus) {
        this.autoRefreshCache(route)
      }
    },
    handleUnpinClick(tag) {
      const source = this.contextMenu.tag ? 'contextMenu' : 'pinIcon'
      this.$store.commit('UNPIN_CACHE_ROUTE', tag)
      this.closeContextMenu()
      quick('click', 'tag_unpin_click', {
        tagName: tag.title,
        tagPath: tag.path,
        source,
      })
      trackClick('tag_unpin_click', {
        tagName: tag.title,
        tagPath: tag.path,
        source,
      })
    },
    handlePinClick(tag) {
      this.$store.commit('PIN_CACHE_ROUTE', tag)
      this.closeContextMenu()
      quick('click', 'tag_pin_click', {
        tagName: tag.title,
        tagPath: tag.path,
      })
      trackClick('tag_pin_click', {
        tagName: tag.title,
        tagPath: tag.path,
      })
    },
    openContextMenu(e, tag) {
      const menuWidth = 100
      const menuHeight = 36
      let x = e.clientX
      let y = e.clientY
      if (x + menuWidth > window.innerWidth) {
        x = window.innerWidth - menuWidth - 8
      }
      if (y + menuHeight > window.innerHeight) {
        y = window.innerHeight - menuHeight - 8
      }
      this.closeContextMenu()
      this.contextMenu = {
        x,
        y,
        tag,
      }
    },
    closeContextMenu() {
      this.contextMenu.tag = null
    },
    onDocumentClick() {
      if (this.contextMenu.tag) {
        this.closeContextMenu()
      }
    },
  },
  mounted() {
    this.$store.commit('RESTORE_PINNED_TABS')
    this.$EventBus.$on('deleteCurrentRoute', this.handleRemoveCurrent)
    this.$EventBus.$on('refreshParent', this.autoRefreshCache) // 只是刷新父路由
    document.addEventListener('click', this.onDocumentClick)
  },
  beforeDestroy() {
    this.$EventBus.$off('deleteCurrentRoute', this.handleRemoveCurrent)
    this.$EventBus.$off('refreshParent', this.autoRefreshCache)
    document.removeEventListener('click', this.onDocumentClick)
  },
}
</script>
<style lang="less" scoped>
.tag_container_outer {
  background: rgb(255, 255, 255);
  position: relative;
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.04);
}
.tags_container_inner {
  position: relative;
  display: flex;
  // height: 45px;
  overflow-x: auto;
  padding: 6px 30px 6px 20px;
  flex-wrap: no-wrap;
  -ms-overflow-style: none; /* Internet Explorer 10+ */
  scrollbar-width: none; /* Firefox */
  ::v-deep .el-tag--light {
    margin-left: 5px;
    a {
      color: rgba(0, 0, 0, 0.45);
    }
  }
  ::v-deep .el-tag {
    height: 26px;
    line-height: 26px;
    font-size: 13px;
    // padding: 0 10px;
    border-radius: 5px;
    background-color: #fff;
    padding: 0, 20px;
  }
  ::v-deep .active {
    background: #f3f6ff;
    a {
      color: #276bec;
    }
  }
}
.bottom_liner {
  width: 100%;
  height: 7px;
  opacity: 1;
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0.05) 3%,
    rgba(0, 0, 0, 0) 99%
  );
}
::v-deep .el-icon-arrow-left {
  font-size: 15px;
  cursor: pointer;
  font-weight: bold;
  &:hover {
    color: #2e7eff;
  }
}
::v-deep .el-icon-arrow-right {
  font-size: 15px;
  cursor: pointer;
  font-weight: bold;
  &:hover {
    color: #2e7eff;
  }
}
.tags_container_inner::-webkit-scrollbar {
  display: none; /* Safari and Chrome */
}
.arrow-icon {
  background: rgb(247, 248, 250);
  display: inline-block;
  z-index: 5;
  height: 38px;
  line-height: 38px;
}
.arrow-icon-left {
  position: absolute;
  left: 0px;
  left: 0px;
  padding-left: 2px;
  padding-right: 2px;
  box-shadow: 4px 0px 8px 0px rgba(0, 0, 0, 0.1);
}
.arrow-icon-right {
  position: absolute;
  right: 0px;
  padding-right: 4px;
  padding-left: 2px;
  top: 0;
  box-shadow: -4px 0px 8px 0px rgba(0, 0, 0, 0.1);
}
.tag-pin-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  margin-left: 4px;
  margin-top: -1px;
  color: #276bec;
  cursor: pointer;
  flex-shrink: 0;
  border-radius: 50%;
  font-size: 14px;
  &:hover {
    color: #2e7eff;
    background: rgba(46, 126, 255, 0.1);
  }
}
.tab-context-menu {
  position: fixed;
  z-index: 9999;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  padding: 4px 0;
  min-width: 100px;
  .context-menu-item {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 16px;
    font-size: 13px;
    color: #303133;
    cursor: pointer;
    white-space: nowrap;
    &:hover {
      background: #f3f6ff;
      color: #276bec;
    }
  }
  .context-menu-icon {
    display: inline-flex;
    align-items: center;
    flex-shrink: 0;
    color: #303133;
    font-size: 16px;
  }
}</style>
